module.exports = {"420602001":"真武山街道","420602002":"古城街道","420602003":"庞公街道","420602004":"檀溪街道","420602005":"隆中街道","420602006":"余家湖街道","420602100":"欧庙镇","420602101":"卧龙镇","420602200":"尹集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420602.json
// module id = 1589
// module chunks = 0